import { FC, useState } from "react";
import styled from "styled-components";

import FiltersDropdown from "@/components/FilterDropdown";
import FilterButton from "@/components/FilterDropdown/FilterButton";
import FilterRadioButton from "@/components/FilterDropdown/FilterRadioButton";
import {
  FilterGroupBody,
  FilterGroupHeader,
  FilterGroupTitle,
  FilterWrap,
} from "@/components/FilterDropdown/Parts";

const StyledFiltersDropdown = styled(FiltersDropdown)`
  max-height: 336px;
  width: 220px;
`;

const Label = styled.span`
  text-transform: capitalize;
`;

const types = ["carousel", "video", "image", "other"];

interface Props {
  activeType: string;
  setActiveType: React.Dispatch<React.SetStateAction<string>>;
}

const PostTypeFilter: FC<Props> = ({ activeType, setActiveType }) => {
  const [showFilters, setShowFilters] = useState(false);

  return (
    <FilterWrap>
      <FilterButton
        text="Type"
        isActive={showFilters}
        onClick={(e) => {
          e?.stopPropagation();
          setShowFilters((prev) => !prev);
        }}
        filterApplied={!!activeType}
      />
      {showFilters && (
        <StyledFiltersDropdown onClose={() => setShowFilters(false)}>
          <FilterGroupHeader>
            <FilterGroupTitle>Filter by Type:</FilterGroupTitle>
          </FilterGroupHeader>
          <FilterGroupBody>
            <FilterRadioButton
              id={`postType`}
              value=""
              checked={!activeType}
              setValue={(newValue) => setActiveType(newValue)}
            >
              All Types
            </FilterRadioButton>
            {types.map((type, index) => (
              <FilterRadioButton
                key={index}
                id={`postType${index}`}
                value={type}
                checked={activeType === type}
                setValue={(newValue) => setActiveType(newValue)}
              >
                <Label>{type}</Label>
              </FilterRadioButton>
            ))}
          </FilterGroupBody>
        </StyledFiltersDropdown>
      )}
    </FilterWrap>
  );
};

export default PostTypeFilter;
